import { MpMakerMconUtil } from '@modules/NewMaker/Mcon/S/Function/mcon.ts';

/**
 * Deletes images for the canvas editor.
 * @param product_faces2
 * @param image_ids 제거할 image ids
 */
export const deleteImagesForCanvasEditor = async (product_faces2, image_ids) => {
  const allFaces = product_faces2?.value || [];
  if (!image_ids?.length) return;
  const filterNestedDesigns = (designs) => {
    return designs.filter((design) => {
      if (image_ids.includes(MpMakerMconUtil.getImageId(design))) {
        return false;
      }

      // type이 group이면 내부 designs를 재귀적으로 순회하며 삭제
      if (design._data.cv_type === 'cv_group' && Array.isArray(design.objects)) {
        design.objects = filterNestedDesigns(design.objects);
      }

      return true;
    });
  };

  allFaces.forEach((face, index) => {
    face.designs = filterNestedDesigns(face.designs);
  });
};

export function svgFileToEl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(event.target.result, 'image/svg+xml');
      const svgEl = svgDoc.documentElement;

      if (svgEl.tagName !== 'svg') {
        reject(new Error('Provided file is not a valid SVG file.'));
      } else {
        resolve(svgEl);
      }
    };
    reader.onerror = (error) => {
      reject(new Error('Error reading SVG file: ' + error.message));
    };
    reader.readAsText(file);
  });
}

/**
 * Deletes images for the vector editor.
 * @param svg_el svg 엘리먼트 혹은 File.
 * @param image_ids 제거할 image ids
 */
export const deleteImagesForVectorEditor = async (svg_el, image_ids) => {
  // image_ids 는 모두 string[] 형태로 바꿈
  image_ids = image_ids.map((id) => String(id));

  let svg_file = null;

  // svg_el 이 File 이여도 svg_el 로직처럼 작동되게
  if (svg_el instanceof File) {
    svg_file = svg_el;

    // File 객체가 svg 파일이 아닐 경우
    if (!svg_el.name.endsWith('.svg')) {
      console.warn('Provided file is not an SVG file.');
      return;
    }

    // File 객체를 읽어서 SVG 엘리먼트로 변환
    svg_el = await svgFileToEl(svg_el);
    if (!svg_el) {
      console.error('Failed to parse SVG file.');
      return;
    }
  }

  const image_elements = svg_el.querySelectorAll(`image`);
  image_elements.forEach((image_el) => {
    const imageId = image_el.getAttribute('data-mpse__image_id');

    if (image_ids.includes(imageId)) {
      // 만악 그 부모가 data-mpse__grouping__model__const__is_group="true" 이면서 (그룹임) 자식이 삭제된 image_el 외에 아무것도 없다면 그 부모도 삭제한다.
      const parent_el = image_el.parentElement;

      image_el.remove(); // 일반 삭제

      if (
        // 부모가 그룹이면서 그 자식이 하나밖에 안남았다면
        parent_el.getAttribute('data-mpse__grouping__model__const__is_group') === 'true' &&
        parent_el.children.length === 1
      ) {
        // 그룹 해제: 자식을 부모의 부모로 이동
        const grandparent_el = parent_el.parentElement;
        if (grandparent_el) {
          grandparent_el.appendChild(parent_el.children[0]);
        }
        parent_el.remove(); // 빈 그룹 삭제
      }
    }
  });

  if (svg_file) {
    // File 객체로부터 SVG 엘리먼트를 수정한 후 다시 File 객체로 변환하는 로직이 필요할 경우 추가 구현 필요
    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg_el);
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    return new File([blob], svg_file.name || 'modified.svg', { type: 'image/svg+xml' });
  }

  return svg_el;
};
